// [note] use rcd.__id trigger descending updates through useEffects.

import "./RcdEdit.css";
import React, { useState, useRef, useLayoutEffect } from "react";
import { createRoot } from "react-dom/client";
import {useRcd, useRcds, useTblDef, isNewRcd, regUses} from "../../axios_with_token.js";

import getWidget from "../../widgets/widgets.js";

import {useForm} from "react-hook-form";
import { addTblRcds, randomUUID } from "../../axios_with_token.js";

const getTblDefRcdDefaults = (tblDef, rcdDefault)=>{
    const tblDefDefaults = {};
    const inputSettings = tblDef.inputSettings||{};
    Object.keys(inputSettings).forEach(fldName=>{
        const fldDef = inputSettings[fldName]||{};
        const dflt = fldDef.default || fldDef.defaultFn;
        if(dflt !== undefined){
            tblDefDefaults[fldName] = dflt.constructor==Function?dflt():dflt;
        }
    })
    const _rcdDefault = {...tblDefDefaults, ...rcdDefault};
    delete _rcdDefault.__id;

    return _rcdDefault;
}

const getGroups = tblDef=>{
    const entries = {};
    const groups = [
        {
            name: "main",
            flds:""
        }
    ];

    if(tblDef){
        // [] fld entries
        const inputSettings = tblDef.inputSettings||{};
        Object.keys(inputSettings).forEach((fldName, idx)=>{
            const fldDef = inputSettings[fldName] || {};
            entries[fldName] = {
                type: fldDef.type || "input",
                fldName: fldName,
                def: fldDef
            }
        });

        // [] embed entries
        const embedInputs = tblDef.embedInputs||{};
        const embedFlds = Object.keys(embedInputs);
        for(let i in embedFlds){
            const embedName = embedFlds[i];
            entries[embedName] = {
                type: "embed",
                fldName: embedName,
                // tblName: embedDef.tblName
                def: {...embedInputs[embedName], type: "embed"}
            };
        };


        // user defined flds takes priority, then main flds+embeds=entiries
        const flds = tblDef.flds?tblDef.flds.split(","):Object.keys(entries);
        // [] put flds in group, default is main
        (flds||[]).forEach((fldName, idx)=>{
            //[] get fld def, maybe main rcd fld or embed tbl
            let fldDef = inputSettings[fldName] || embedInputs[fldName] || {};
            let group = groups[0];
            if(fldDef.group){
                let groupFound = groups.find(grp=>grp.name===fldDef.group);
                if(groupFound){
                    group = groupFound;
                }else{
                    let newGroup = {
                        name: fldDef.group,
                        flds:[]
                    };
                    groups.push(newGroup);
                    group = newGroup;
                }
            }
            group.flds=[group.flds,fldName].filter(a=>a).join(",");
        });

    }

    return {
        groups: groups.map(group=>{
            group.flds = group.flds.split(',').map(fldName=>entries[fldName]);
            return group;
        }),
        entries
    };
}

const mkTpl = groups=>{
    const tabs = groups.map(group=>group.name);
    const mkGrpTpl = group=>{
        return <div><table className="table">
            <tbody>
                {
                    (group.flds||[]).map((fldDef, fldIdx)=>{
                        fldDef = fldDef || {};
                        return <tr key={fldIdx}>
                            <td style={{width: 'auto', paddingRight: '1em', textAlign: 'right', padding: '0.5em'}}>{fldDef.caption || fldDef.fldName}</td>
                            <td style={{width: '100%', padding: '0.5em'}} data-fldname={fldDef.fldName}></td>
                        </tr>
                    })
                }
            </tbody>
        </table></div>;
    }

    const tplid = `tplid-${window._ww_tools.uuidv4()}`;
    return <div>
        {/*  nav-pills  */}
        {
            tabs.length>1&&<ul className="nav nav-tabs" id="pills-tab" role="tablist">
                {tabs.map((tabName, tabIdx)=>{
                    const tabId = `${tplid}-${tabName}`;
                    const group = groups[tabIdx] || {};
                    return <li className="nav-item" role="presentation" key={tabId}>
                        <button className={["nav-link", tabIdx?"":"active"].join(' ')} 
                            type="button" 
                            role="tab" aria-controls="pills-home"
                            data-bs-toggle="tab"
                            data-bs-target={"#"+tabId}
                            aria-selected={tabIdx?"false":"true"}
                            aria-controls={tabId}
                        >{group.caption || tabName}</button>
                    </li>
                })}
            </ul>
        }
        <div className="tab-content" id="pills-tabContent">
            {
                tabs.map((tabName, tabIdx)=>{
                    const tabId = `${tplid}-${tabName}`;
                    const group = groups[tabIdx] || {};
                    // [] tab-pane is important, otherwise tab contents' visibility is used rather than display
                    return <div className={[tabs.length>1&&("tab-pane " + (tabIdx?"":" show active")), 'm-3'].join(' ')}
                        key={tabId}
                        id={tabId}
                        role="tabpanel"
                        // aria-labelledby="pills-matched-tab"
                    >
                        {/* {group.caption || tabName} */}
                        {mkGrpTpl(group)}
                    </div>
                })
            }
        </div>
    </div>
}

const mkFldEntry = (fldName, form, fldDef)=>{
    if(!fldName || !form || !fldDef) return <>entry [{fldName}] settings missed.</>;
    if(fldDef.type=='embed'){
        return fldDef.jsx;
    }else{
        const Widget = getWidget(fldDef.type);

        if(Widget){
            return <Widget 
                fldName={fldName}

                form={form}
                fldDef={fldDef}
            />
        }else{
            const DefaultWgt = getWidget('input');
            return <>
                <span style={{color: "red"}}>{fldDef.type}</span>
                <DefaultWgt 
                    fldName={fldName}

                    form={form}
                    fldDef={fldDef}
                />
            </>
        }
    }
}

const fillTplInputs = (refForm, form, entries, opts)=>{
    opts = opts || {};
    // [] fldName: passedInInputs
    const inputs = opts.inputs || {};
    const currentForm = refForm.current;
    if(currentForm){
        currentForm.querySelectorAll(`[data-fldname]`).forEach((fldCon, idx)=>{
            const fldName = fldCon.getAttribute("data-fldname");
            if(!fldCon.insertPoint){
                const insertPoint=createRoot(fldCon);
                fldCon.insertPoint = insertPoint;
            }
            // [info] during render, new register will be done, which defines what flds will be get data from and upload
            // fldCon.insertPoint.render(mkFldEntry(fldName, idx));
            // [] rcd is passed in as init value
            if(inputs[fldName]){
                const Comp = inputs[fldName];
                fldCon.insertPoint.render(<Comp
                    fldName = {fldName}
                    form = {form}
                    fldDef = {(entries[fldName] || {}).def}
                ></Comp>);
            }else{
                fldCon.insertPoint.render(mkFldEntry(fldName, form, (entries[fldName] || {}).def));
            }
        });
        
        // [patch important] in firefox, the browser automatically add contenteditable="true" and prevent select from working
        // [further] the tpl prepared by tinymce is in design mode, which add contenteditable="true"
        currentForm.querySelectorAll(`[ contenteditable="true"]`).forEach((fldCon, idx)=>{
            fldCon.setAttribute('contenteditable', false);
        });
    }
}

const EmbedRcd = ({embedRcdForms, embedFldNames, embedTblDef, embedRcd, embedTblName, embedDef})=>{
    const rcdForm = useForm({
        shouldUnregister: true,
        defaultValues: embedRcd
    });
    rcdForm.register('__id');
    const refRcd = useRef();
    embedRcdForms[embedRcd.__id] = {
        tblName: embedTblName,
        form: rcdForm,
        connectFld: embedDef.connectFld
    };

    const refData = useRef({
        init:false
    });
    
    return <>
        {embedFldNames.map((embedFldName, embedFldNameIdx)=>{
            return (embedFldName==embedDef.connectFld)?null:<td key={embedFldName} ref={!embedFldNameIdx?refRcd:null}>
                {mkFldEntry(`${embedFldName}`, rcdForm, (embedTblDef.inputSettings||{})[embedFldName]||{})}
            </td>
        })}
    </>;
};

const Embed = ({embedName, tblDef, embedDef, mainRcd, editFlds, embedRcdForms, rcdDefault, embedLoadings, embedId})=>{
    const [rcds, setRcds] = useState([]);
    const refEmbed = useRef();
    const refData = useRef({
        init:false,
        addedRcds: []
    });

    const {regUse, isLoading, hasError, getErrMsgs} = regUses();

    const {data: embedTblDefGot} = regUse(useTblDef(embedDef.srcTbl));
    const embedTblDef = embedTblDefGot || {};


    let filter = {};
    // filter[embedDef.connectFld] = `^${mainRcd.__id}$`;

    // [] connectFld is a must have
    if(embedDef.connectFld){
        if(embedDef.mkConnectFlt){
            filter = embedDef.mkConnectFlt(mainRcd||{});
        }else{
            filter[embedDef.connectFld] = `^${(mainRcd||{}).__id}$`;
        }
    }else{
        throw(`[RcdEdit|Embed] error: no connectFld for ${embedName}`)
    }
    const {data: embedRcds} = regUse(useRcds(embedDef.srcTbl, 0, 10, filter));

    embedLoadings[embedId] = isLoading();

    const {groups, entries} = getGroups(tblDef);
    const embedFldNames = (editFlds || (embedTblDef||{}).editFlds || Object.keys((embedTblDef||{}).inputSettings||{}).join(',') || '').split(',').filter(a=>a);

    if (isLoading()) {
        return <div>Loading...</div>;
    }

    if (hasError()) {
        return <div>Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }
    
    // [] rcd default
    const _rcdDefault = getTblDefRcdDefaults(embedTblDef, rcdDefault);

    const addRcd = _=>{
        // [] add defaults
        setRcds([...rcds, {
            ..._rcdDefault,
            __id: `tempid-${randomUUID()}`
        }]);
    };

    const delRcd = rcdIdx=>{
        delete embedRcdForms[rcds[rcdIdx].__id];
        console.log('embedRcdForms:', embedRcdForms, rcdIdx, rcds);
        const newRcds = rcds.map((rcd, idx)=>{
            // [] when update rcd, keep __id to connect embedRcdForms
            return (idx != rcdIdx)?{...embedRcdForms[rcd.__id].form.getValues(), __id:rcd.__id}:null;
        }).filter(a=>a);
        setRcds(newRcds);
    };

    // [] init rcds
    if(!refData.init && embedRcds.rcds){
        setRcds([...embedRcds.rcds]);
        refData.init = true;
    }

    return <div ref={refEmbed}>
        <table className="table" role={"embedTbl"}
            style={{maxWidth: "100%"}}
        >
            <thead>
                <tr>
                    <th><button type="button"
                        className="btn btn-primary"
                        onClick={evt=>{addRcd()}}
                    >+</button></th>
                    {(embedFldNames).map(embedFldName=>{
                        return (embedFldName==embedDef.connectFld)?null:<th key={randomUUID()}>
                            {(embedTblDef.inputSettings[embedFldName]||{}).caption || embedFldName}
                        </th>
                    })}
                </tr>
            </thead>
            <tbody>
                {rcds.map((embedRcd, embedRcdIdx)=>{
                    return <tr
                        key={randomUUID()}
                    >
                        <td><button type="button"
                            className="btn btn-primary"
                            onClick={evt=>{delRcd(embedRcdIdx)}}
                        >-</button></td>
                        <EmbedRcd
                            key={embedRcd.__id}
                            embedRcdForms={embedRcdForms}
                            embedFldNames={embedFldNames}
                            embedTblDef={embedTblDef}
                            embedDef={embedDef}
                            embedRcd={embedRcd}
                            embedTblName={embedDef.srcTbl}
                        ></EmbedRcd>
                    </tr>
                })}
            </tbody>
        </table>
    </div>
}

const embedsKey = `embedsKey-${randomUUID()}`;
export function useEmbeds({tblDef, mainRcd, loadings}){
    const embedError = null;
    const refData = useRef({
        embedLoadings: {
            parentLoading: loadings
        }
    });

    const embeds = {};
    const loading = !!Object.values(refData.current.embedLoadings).map(embedLoading=>!!Object.values(embedLoading).filter(a=>a).length).filter(a=>a).length;
    try{
        if(!loading){
            const embedInputs = (tblDef||{}).embedInputs || {};
            Object.keys(embedInputs).forEach(embedName=>{
                // [important] embedRcdForms and embedLoadings must be defined inside the forEach, otherwise they are shared.
                const embedRcdForms = {};
                const embedLoadings = [];
                refData.current.embedLoadings[embedName] = refData.current.embedLoadings[embedName] || [];
                const embedDef = embedInputs[embedName];
                embeds[embedName] = {
                    embedRcdForms,
                    embedLoadings,
                    component: <Embed
                        embedName={embedName}
                        tblDef={tblDef}
                        embedDef={embedDef}
                        mainRcd={mainRcd}
                        embedRcdForms={embedRcdForms}
                        embedLoadings={refData.current.embedLoadings[embedName]}
                        embedId={`embedid-${randomUUID()}`}
                    ></Embed>
                };
            });

            return {
                data: embeds,
                loading,
                error: embedError
            }            
        }else{
            return {
                data:null,
                loading,
                error:null
            }                  
        }
    }catch(err){
        return {
            data:null,
            loading:false,
            error: err
        };

    }
}

export function useRcdDataEdit({tblName, rcd, formId}){
}

export function useRcdEdit({tblName, rcdId, formId, rcdDefault, tpl, inputs, curValues, reset}){
    const {errors, regUse, isLoading, hasError, getErrMsgs} = regUses();

    const refData = useRef({
        forms: {},
        rcdDefault
    });

    const setRcdDefault = rcdDefault=>{
        if(refData.current){
            refData.current.rcdDefault = rcdDefault;
        }
    }

    const getRcdDefault = _=>{
        return (refData.current&&refData.current.rcdDefault)||{};
    }

    const { data: rcdGot, invalidate:invalidateRcd } = regUse(useRcd(tblName, rcdId, getRcdDefault(), {reset}));
    const rcd=rcdGot || {};
    const { data: tblDefGot } = regUse(useTblDef(tblName));
    const tblDef = tblDefGot || {};

    let data;
    // [] if new rcd, load default
    if(!rcd.__id || isNewRcd(rcd)){
        const _rcdDefault = getTblDefRcdDefaults(tblDef, getRcdDefault());
        Object.keys(_rcdDefault).forEach(k=>{
            if(rcd[k]!==undefined)rcd[k]=_rcdDefault[k];
        });
    }
    // [bug] here the rcd got is not the one specified by rcdId
    // [cause] the call returned cached data, not from remote. but why cached not right?, and why main RcdEdit displays right?
    // [this is a snapshot]
    data = ({})=><>
        {/* <h5>{tblName}-{(rcd||{}).__id}</h5> */}
        <RcdEdit
            // tblName={tblName}
            tblDef={tblDef}
            rcd={rcd}
            formId={formId}
            forms={refData.current.forms}
            tblName={tblName}
            tpl={tpl}
            inputs={inputs}
            curValues={curValues}
        ></RcdEdit>
    </>

    const updateRemoteRcd = async _=>{
        // [remote interface] '/addtblrcds/<string:jsonPath>/<string:tblName>'
        // mainRcds = request.json.get('rcds', [])
        // embedTbls = request.json.get('embedTbls', {})
        const upData = {};

        // main table
        const mainForm = refData.current.forms.mainForm;
        upData.rcds = [mainForm.form.getValues()];
        upData.rcds.forEach(mainRcd=>{
            if(isNewRcd(mainRcd)){
                delete mainRcd.__id;
            }
        })
        const tblName = mainForm.tblName;

        // embeds
        const embedData = {};
        const embeds = refData.current.forms.embeds || {};
        console.log('embeds:', embeds);
        Object.values(embeds).forEach(embed=>{
            const rcdForms = embed.embedRcdForms;
            console.log('rcdForms:', rcdForms);
            Object.values(rcdForms).forEach(rcdForm=>{
                embedData[rcdForm.tblName] = embedData[rcdForm.tblName] || {};
                embedData[rcdForm.tblName].rcds = embedData[rcdForm.tblName].rcds || [];
                const rcd = rcdForm.form.getValues();
                if(isNewRcd(rcd)){
                    delete rcd.__id;
                }
                // [!!!important] delete temporary rcd.__id
                // if(rcd.__id && String(rcd.__id).startsWith(`tempid-`)){
                //     delete rcd.__id;
                // }
                embedData[rcdForm.tblName].rcds.push(rcd);
                embedData[rcdForm.tblName].connectFld = rcdForm.connectFld;
            })
        })
        upData.embedTbls = embedData;

        console.log('upData:', upData, embedData);
        const r = await addTblRcds(tblName, upData.rcds, upData.embedTbls);

        invalidateRcd();
        return r;
    }

    return {
        data,
        loading: isLoading(),
        error: errors,
        forms:refData.current.forms,

        setRcdDefault,
        getRcdDefault,

        invalidateRcd,
        updateRemoteRcd,
    }
}

// [!!!important] curValues must be false to use rcd value, not {}
export default function RcdEdit({tblDef, rcd, formId, forms, tblName, tpl, inputs, curValues}){
    const refForm = useRef();
    const refData = useRef({
        init:false
    });

    const {regUse, isLoading, hasError, getErrMsgs, DefaultResponse} = regUses();

    const { data: embeds } = regUse(useEmbeds({tblDef, mainRcd:rcd, loadings:[]}));

    // [problem] rcd not ready here
    // const oldForm = ((forms||{}).mainForm||{}).form;
    // if(oldForm){
    //     console.log(oldForm.getValues());
    // }
    const formEdit = useForm({
        shouldUnregister: true,
        defaultValues: curValues||rcd
    });
    formEdit.register('__id');

    // [] pass forms to parent
    if(forms){
        forms.mainForm = {
            form:formEdit,
            tblName: tblName
        };
        forms.embeds = embeds;
    }

    const onSubmit = data=>{
        // console.log('onSubmit data:', formEdit.getValues());
        // console.log('embeds:', embeds);
        Object.keys(embeds).map(embedName=>{
            const embedData = embeds[embedName];
            Object.values(embedData.embedRcdForms).forEach((rcdForm, rcdFormIdx)=>console.log(`embedForm values(${rcdFormIdx}):`, rcdForm.form.getValues()));
            // embedData.embedRcdForms.map(embedForm=>{
            //     console.log('embedForm values:', embedForm.getValues());
            // });
        });
        // embeds.embedRcdForms.map(embedForm=>{
        //     console.log('embedForm values:', embedForm.getValues());
        // })
        // // embeds
        // // console.log('submit data:', JSON.stringify(data));
        // const upData = {};
        // upData.rcds = [data];

        // const embedTbls = {};
        // Object.keys(entries).forEach(entName=>{
        //     const entDef=entries[entName];
        //     if(entDef.ref){
        //         const refEmbed = entDef.ref;
        //         // [] this cause error in form tpl
        //         if(!refEmbed.current)return;
        //         let clonedFrm = refEmbed.current.cloneNode(true);
        //         if(clonedFrm !== 'FORM'){
        //             let tmpFrm = document.createElement('FORM');
        //             tmpFrm.appendChild(clonedFrm);
        //             clonedFrm = tmpFrm;
        //         }
        //         const embedFrmData = new FormData(clonedFrm);
        //         const rcds = [];
        //         let rcd = {};
        //         for (const pair of embedFrmData.entries()) {
        //             const fldName = pair[0].split(":").pop();
        //             if(fldName in rcd){
        //                 if(Object.keys(rcd).length>0)rcds.push(rcd);
        //                 rcd = {};
        //             }
        //             rcd[fldName] = pair[1];
        //         }
        //         if(Object.keys(rcd).length>0)rcds.push(rcd);
                
        //         // embedTbls[entDef.def.tblName] = (embedTbls[entDef.def.tblName] || []).concat(rcds);
        //         embedTbls[entDef.fldName] = embedTbls[entDef.fldName] || {
        //             rcds: [],
        //             connectFld: entDef.def.connectFld,
        //             tblName: entDef.def.tblName
        //         };
        //         embedTbls[entDef.fldName].rcds = embedTbls[entDef.fldName].rcds.concat(rcds);
        //         // presets
        //         const embedDef = (entries[entDef.fldName] || {}).def || {};
        //         embedTbls[entDef.fldName].rcds = embedTbls[entDef.fldName].rcds.map(rcd=>{
        //             if(embedDef && embedDef.mkPreset){
        //                 return {...rcd, ...embedDef.mkPreset(data)};
        //                 // console.log("embedDef.mkPreset:", embedDef.mkPreset(data), data);
        //             }else{
        //                 return rcd;
        //             }
        //         });
        //     }
        // })
        // upData.embedTbls = embedTbls;

        // const frmdata = new FormData();
        //         // []get all rcds array in main and embeded tables
        // let tgtRcds = [...upData.rcds];
        // for(let embedName in (upData.embedTbls||{})){
        //     tgtRcds = [...tgtRcds, ...(upData.embedTbls[embedName].rcds||[])];
        // }

        // if(props.mode === "deletemode"){
        //     // [] mark delete
        //     for(let i in tgtRcds){
        //         const rcdId = tgtRcds[i].__id;
        //         // delete everything in rcd
        //         Object.keys(tgtRcds[i]).forEach(key => {
        //             delete tgtRcds[i][key];
        //         })
        //         tgtRcds[i]["__id"] = rcdId;
        //         tgtRcds[i]["__delete"] = 1;
        //     }

        //     axios_with_token({
        //         method: "post",
        //         data: upData,
        //         __tbl: props.tblName,
        //         __action: "addtblrcds"
        //     }).then(res=>{
        //         props.closeDlg&&props.closeDlg();
        //         props.updateList&&props.updateList();
        //         props.submitCb(res);
        //     }).catch(err=>console.error(err));
        // }else{
        //     // [] save new / edit
        //     // images, files upload
        //     for(let uuid in formCache){
        //         if(formCache[uuid].url){
        //             frmdata.append(uuid+"_file_data", window._ww_tools.b64toBlob((formCache[uuid].url).split(',')[1]));
        //             frmdata.append(uuid+"_file_name", formCache[uuid].fileName || `file-${window._ww_tools.uuidv4()}`);
        //         }
        //     }
        //     frmdata.append('uuids', Object.keys(formCache));
        //     axios_with_token({
        //         method: "post",
        //         headers: { "Content-Type": "multipart/form-data" },
        //         data: frmdata,
        //         __action: 'uploadfiles',
        //         __useFormData: true
        //     }).then(res=>{
        //         if(res.data.status){
        //             console.log('res after :', res);
        //             //[] replace file/img uuid with returned url
        //             // [toconsider] this could also moved to backend
        //             for(let i in tgtRcds){
        //                 let rcd = tgtRcds[i];
        //                 for(let k in rcd){
        //                     // [] rcd[k] might be embeded flds, because we called setValue on it ---> add logic in setFormValue to avoid setValue call for embeded
        //                     if((inputSettings[k]===undefined)&&(embedFlds[k]===undefined)&&(!k.startsWith('_'))){
        //                         console.warn(`field [${k}] not in inputsettings or embed fields.`);
        //                     }

        //                     if(rcd[k]&&(rcd[k].constructor === String)){
        //                         for(let __uuid in res.data.data){
        //                             console.log(`${k}: replacing [${__uuid}] in [${rcd[k]}] to [${res.data.data[__uuid].url}]`);
        //                             rcd[k] = rcd[k].replace(`${__uuid}`, res.data.data[__uuid].url)
        //                         }
        //                     }
        //                 }
        //             }

        //             // [] save rcds
        //             console.log('upData:', upData);
        //             return axios_with_token({
        //                 method: "post",
        //                 data: upData,
        //                 __tbl: props.tblName,
        //                 __action: "addtblrcds"
        //             });
        //         }else{
        //             console.log('[uploade images/files error]',res)
        //             throw(res.msg);
        //         }
        //     }).catch(err=>console.error(err))
        //     .then(res=>{
        //         props.closeDlg&&props.closeDlg();
        //         props.updateList&&props.updateList();

        //         // highlight new / changed record
        //         props.submitCb(res);
        //     });
        // }
    }

    const {groups, entries} = getGroups(tblDef);
    useLayoutEffect(_=>{
        fillTplInputs(refForm, formEdit, entries, {
            inputs
        });
        // if(rcd && !refData.init){
        //     Object.keys(rcd).forEach(fldName=>{
        //         const oldVal = formEdit.getValues()[fldName];
        //         const newVal = rcd[fldName];
        //         formEdit.setValue(fldName, newVal);
        //     });            
        //     refData.init = true;
        // }
    });

    if (isLoading()) {
        return <div>Loading...</div>;
    }

    if (hasError()) {
        return <div>[RcdEdit] Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }

    {
        // console.log('-----------------------embeds:', embeds);
        Object.keys(embeds).forEach(fldName=>{
            entries[fldName].def.jsx = <>
                {embeds[fldName].component}
            </>;
        });
    }

    return <DefaultResponse>
        <form
            id={formId}
            onSubmit={evt=>{
                evt.preventDefault();
                onSubmit();
            }}
            ref={refForm}
        >
            {tpl || mkTpl(groups)}
        </form>
    </DefaultResponse>;

}
